import React, { useState } from 'react'
import { toast } from 'react-toastify';
import axiosFileInstance from '../../hooks/axiosFileInstance';
import useAuth from '../../hooks/useAuthContext';
import CsvDownloadButton from 'react-json-to-csv'

const UploadMember = ({close, refetchData }) => {
    const {userData} = useAuth()
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false)

    const csvData = [
        { 'S/N': '', 'User Type (individual/company)': '',
            Title: '', 'Membership ID': '', Lastname: '',
            Firstname: '', Middlename: '', Email: '', 
            'DOB (mm/dd/yyyy)': '', Phone: '', Address: '',
            'Company Name (required only if user type is `company`)': ''
        },
    ];

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        // Check if the selected file is a CSV file
        if (file && file.name.endsWith('.csv')) {
            setSelectedFile(file);
        } else {
            // Handle invalid file type (e.g., display an error message)
            toast.error('Please select a CSV file.');
            event.target.value = ''; // Clear the file input
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
    
        setLoading(true)
        axiosFileInstance.post(`/association/associations/members/upload/${userData.userInfo.id}`, {csv_file: selectedFile})
            .then(res => {
                toast.success(res.data.message)
                refetchData()
                close()
            })
            .catch(err => {
                console.log(err.response.data);
                toast.error(err.response.data.message)
            })
            .finally(() => setLoading(false))
    };

  return (
    <div>
        <div className="row my-3">
            <div className="col-md-6" style={{borderRight: '2px solid red'}}>
                <h3>Step 1</h3>
                <p className='text-muted my-4'>Download csv template</p>
                <CsvDownloadButton data={csvData} delimiter=',' className='btn btn-info' filename='new_members.csv' />
            </div>
            <div className="col-md-6">
                <h3>Step 2</h3>
                <form onSubmit={handleSubmit}>
                    <div>
                        <label for="formFile" className="form-label">Upload CSV</label>
                        <input 
                            accept=".csv" 
                            className="form-control" 
                            type="file"
                            onChange={handleFileChange}
                        />
                    </div>
                    <div className="mt-3 hstack gap-2 justify-content-end">
                        <button className='btn btn-primary px-5' type="submit" disabled={!selectedFile || loading}>
                            {loading ? <div className="spinner-border spinner-border-sm text-light"></div> : 'Upload'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  )
}

export default UploadMember
